export enum NotificationType {
    none = 0,
    ticket = 1,
    reply = 2,
    mentionInNote = 3,
    mentionInReply = 4,
    ticketAssignment = 5,
    answerToNote = 6,
    subReply = 7,
    ticketReminder = 8,
    ticketSurveyResponseAdded = 9,
    replyReminder = 10,
    ticketMovedToUserCategory = 11,
    emailDeliveryStatusUpdate = 12,
}
